import { render, staticRenderFns } from "./DPHL.vue?vue&type=template&id=9ba86286"
import script from "./DPHL.vue?vue&type=script&lang=js"
export * from "./DPHL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports